import { Pipe, PipeTransform } from '@angular/core'
import CONTRACT_BULK_ACTION_TYPE from '../../../constants/contractBulkActionType.constant'

@Pipe({
    name: 'displayContractBulkActionTypeName',
    standalone: false
})
export class DisplayContractBulkActionTypeNamePipe implements PipeTransform {
    transform(actionType: any): string {
        switch (actionType) {
            case CONTRACT_BULK_ACTION_TYPE.massAppendices:
                return 'Hromadné vygenerování dodatků smluv'
            case CONTRACT_BULK_ACTION_TYPE.massChangeContractState:
                return 'Hromadná změna stavu'
            case CONTRACT_BULK_ACTION_TYPE.massCopyContracts:
                return 'Automatické vytvoření kopií smluv'
            case CONTRACT_BULK_ACTION_TYPE.massCreateContractDocuments:
                return 'Hromadné vytvoření dokumentů'
            case CONTRACT_BULK_ACTION_TYPE.massCreatePayments:
                return 'Hromadné vytvoření plateb'
            case CONTRACT_BULK_ACTION_TYPE.massEndContracts:
                return 'Hromadné ukončení smluv'
            case CONTRACT_BULK_ACTION_TYPE.reprice:
                return 'Přecenění smluv'
            case CONTRACT_BULK_ACTION_TYPE.repriceAndInflationIncrease:
                return 'Přecenění smluv a navýšení smluv o inflaci'
            case CONTRACT_BULK_ACTION_TYPE.inflationIncrease:
                return 'Navýšení smluv o inflaci'
            case CONTRACT_BULK_ACTION_TYPE.valorization:
                return 'Valorizace smluv'
            case CONTRACT_BULK_ACTION_TYPE.replaceParcelVersions:
                return 'Výměna verzí parcel na smlouvě'
            default:
                return ''
        }
    }
}
